module.exports = __webpack_public_path__ + "media/photo/electric_idea-be3c9479.jpg";